<nav class="toolbar navbar navbar-light">
    <form class="form-inline" autocomplete="off">
        <button *ngIf="!visibilitySpinner" [disabled]="!trailblazerResult?.Result || trailblazerResult?.Result?.Rows.length === 0" type="button" title="Exportar" class="btn btn-outline-success" (click)="onExportExcel()"><i class="fa fa-file-excel-o"></i> Exportar </button>
        <button *ngIf="visibilitySpinner" type="button" [disabled]="true" class="btn btn-outline-success">
            <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
            Exportando
        </button>
    </form>
</nav>

<form [formGroup]="form" class="container-fluid" autocomplete="off">

    <div class="animated fadeIn">
        <div class="row">
            <div class="col-md-12">
                <h4>Trailblazer</h4>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">

                <div class="card card-accent-success animated fadeIn">
                    <a class="card-header-a" (click)="isCollapsed = !isCollapsed"
                       [attr.aria-expanded]="!isCollapsed" aria-controls="collapseExample">
                        <div class="card-header-buscador">
                            <i class="fa fa-filter"></i> Filtros
                            <i *ngIf="isCollapsed" class="fa fa-caret-down float-right"></i>
                            <i *ngIf="!isCollapsed" class="fa fa-caret-up float-right"></i>
                        </div>
                    </a>
                    <div class="card-body">
                        <!-- Ocultamos solo los campos, para que estén siempre visibles los botones "Buscar y Limpiar" -->
                        <div class="collapse group-filtros" id="collapseFiltros" [ngbCollapse]="isCollapsed">


                            <div class="row">

                                <div class="form-group col-md-4">
                                    <label class="col-form-label required-field" for="inpOrigen">Origen de Datos</label>

                                    <ng-select [items]="listDataViews"
                                               bindLabel="Descripcion"
                                               bindValue="Descripcion"
                                               formControlName="dataView"
                                               loadingText="Cargando..."
                                               [loading]="!listDataViews || listDataViews.length === 0"
                                               notFoundText="Origen de datos no encontrado"
                                               placeholder="-- Seleccione un Origen de Datos --"
                                               clearAllText="Eliminar selección"
                                               [ngClass]="displayFieldCssNgSelect('dataView')">
                                    </ng-select>
                                    <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('dataView','required')">
                                        Origen de Datos es obligatorio
                                    </div>
                                </div>

                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="inpCondiciones">Condiciones</label>

                                    <div class="row">
                                        <div class="col-md-12">

                                            <div class="form-group">
                                                <div class="input-group">

                                                    <input name="Condicion" title="" class="form-control" id="inpCondicion" type="text" formControlName="Condicion" [ngClass]="displayFieldCssNoSubmit('Condicion')">

                                                    <span class="input-group-btn">
                                                        &nbsp;<button name="btnAddCondicion" class="btn btn-list btn-secondary" type="button" title="Añade una Condición" (click)="onAddCondicion()"><i class="fa fa-plus"></i></button>
                                                    </span>

                                                    <div class="invalid-feedback" *ngIf="isFieldInvalidNoSubmit('Condicion','required')">
                                                        Debe especificar una Condición.
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">

                                        <div *ngIf="model?.ClauseCollection?.length > 0" class="col-md-12">

                                            <table class="table table-list table-responsive table-sm">
                                                <tbody>
                                                    <tr *ngFor="let item of model.ClauseCollection">
                                                        <td scope="col">
                                                            <div class="btn-group">

                                                                <button (click)="onDeleteCondicion(item)" title="Eliminar"
                                                                        class="btn btn-sm btn-danger">
                                                                    <i class="fa fa-remove"></i>

                                                                </button>
                                                            </div>
                                                        </td>

                                                        <td scope="col" class="td-list">{{item}}</td>
                                                    </tr>

                                                </tbody>
                                            </table>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group-0 float-right">

                                    <div class="btn-group">
                                        <button name="btnSearch" class="btn btn-secondary btn-sm" type="button" title="Realiza una búsqueda" (click)="onSearchButton()"><i class="fa fa-search"></i> Buscar</button>
                                    </div>

                                    <div class="btn-group">
                                        <button class="btn btn-secondary btn-sm" type="button" title="Limpia los filtros" (click)="onCleanButton()"><i class="fa fa-eraser"></i> Limpiar</button>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>


        <!--https://medium.com/@schneidenbach/restful-api-best-practices-and-common-pitfalls-7a83ba3763b5-->
        <!--https://stackoverflow.com/questions/46434313/angular-4-async-with-loading-and-display-when-empty-->
        <div *ngIf="searchingButton" class="row">
            <div class="col-md-12">
                <div class="card card-accent-success">
                    <div class="card-header-buscador">
                        <i class="fa fa-align-justify"></i> Listado de la Consulta
                    </div>

                    <div class="card-body-grid">


                        <p-table #tableSearch autoLayout="true" [value]="trailblazerResult?.Result?.Rows" [lazy]="true" (onLazyLoad)="onSearchLazy($event)" [paginator]="true"
                                 [columns]="cols" [rows]="trailblazerResult?.PageSize"
                                 [totalRecords]="trailblazerResult?.TotalCount" [loading]="loading"
                                 [ngClass]="displayGridHidden(trailblazerResult?.Result?.Rows)"
                                 styleClass="table table-responsive-sm  table-striped table-sm">
                            <ng-template pTemplate="header" let-columns>
                                <tr>
                                    <th scope="col" *ngFor="let col of columns" [ngStyle]="{'display': col?.display}" [pSortableColumn]="col?.field">
                                        {{col?.header}}
                                        <p-sortIcon [field]="col?.field"></p-sortIcon>
                                    </th>
                                </tr>
                            </ng-template>

                            <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex">
                                <tr>
                                    <td *ngFor="let col of rowData?.Values">
                                        <span>
                                            {{col}}
                                        </span>
                                    </td>
                                </tr>

                            </ng-template>

                        </p-table>
                        <div *ngIf="tableSearch?.totalRecords === 1" class="p-2">Se ha encontrado {{ tableSearch?.totalRecords | number:'1.0-0':'es-ES' }} registro</div>
                        <div *ngIf="tableSearch?.totalRecords > 1" class="p-2">Se han encontrado {{ tableSearch?.totalRecords | number:'1.0-0':'es-ES' }} registros</div>
                        <div class="empty-grid" *ngIf="tableSearch?.totalRecords === 0">No se ha encontrado ningún registro</div>

                    </div>

                </div>
            </div>
        </div>

    </div>

</form>


